import { AxiosRequestHeaders } from "axios";

export function requestAuthorizationHeaderRemover (data: unknown, headers: AxiosRequestHeaders): unknown {
    delete (headers.common as unknown as AxiosRequestHeaders).Authorization;
    return data;
};